var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Documentos que, por determinacao interna, nao devem exibir processos.
 * Para esses documentos zeramos os totais/valores, nao listamos nenhum
 * processo e limpamos o resumo da Tratum IA.
 */
export var BLOCKED_PROCESS_DOCUMENTS = ['04941669169'];
var onlyDigits = function (value) {
    return String(value !== null && value !== void 0 ? value : '').replace(/\D/g, '');
};
export var isProcessBlockedDocument = function (documentNumber) {
    var document = onlyDigits(documentNumber);
    if (!document)
        return false;
    return BLOCKED_PROCESS_DOCUMENTS.some(function (blocked) { return onlyDigits(blocked) === document; });
};
/**
 * Frase padrao que substitui tudo que o resumo da IA falava de processos.
 */
export var ZEROED_PROCESS_SENTENCE = 'No âmbito jurídico, responde a 0 processo(s) trabalhista(s) no valor de ' +
    'R$ 0,00, 0 processo(s) em execução no valor de R$ 0,00 e 0 demais ' +
    'litígio(s) no valor de R$ 0,00.';
// Trechos do resumo da IA que falam de processo/litigio e precisam sair
var PROCESS_SENTENCE = /processo|litígio|litigio|jurídic|juridic|crimin|trabalhista|execução|execucao|judicial|réu|autor/i;
// Marcador temporario para os pontos de milhar (R$ 291.393,68), que nao
// podem ser confundidos com fim de frase
var NUMBER_DOT = '\u0000';
var splitSentences = function (text) {
    return text
        .replace(/(\d)\.(\d)/g, "$1".concat(NUMBER_DOT, "$2"))
        .split('.')
        .map(function (sentence) { return sentence.trim(); })
        .filter(Boolean)
        .map(function (sentence) { return "".concat(sentence.split(NUMBER_DOT).join('.'), "."); });
};
/**
 * Remove do resumo da Tratum IA as frases que falam de processos e coloca a
 * frase zerada no lugar, preservando o resto do texto (Receita Federal,
 * quadro societario, vinculos, protesto, divida ativa e pro credito).
 */
export var zeroSummaryAiProcesses = function (resumeAi) {
    if (!resumeAi || !resumeAi.trim())
        return resumeAi;
    var sentences = splitSentences(resumeAi);
    if (!sentences.length)
        return resumeAi;
    var replaced = false;
    var result = [];
    sentences.forEach(function (sentence) {
        if (PROCESS_SENTENCE.test(sentence)) {
            if (!replaced) {
                replaced = true;
                result.push(ZEROED_PROCESS_SENTENCE);
            }
            return;
        }
        result.push(sentence);
    });
    // Resumo sem nenhuma mencao a processo: entra logo apos a frase de abertura
    if (!replaced) {
        result.splice(Math.min(1, result.length), 0, ZEROED_PROCESS_SENTENCE);
    }
    return result.join(' ');
};
/**
 * Zera todos os campos de processo do resumo da analise, mantendo os demais
 * dados (protesto, divida ativa, cadastrais, etc).
 */
export var zeroAnalysisProcesses = function (data) {
    var emptyType = { total: 0, amount: 0, percentageValueChange: 0 };
    var summaryAi = data.summaryAi;
    return __assign(__assign({}, data), { totalProcesses: 0, totalProcessesActive: 0, totalProcessesInactive: 0, totalProcessesAsAuthor: 0, totalValueAsAuthor: 0, totalProcessesAsDefedant: 0, totalValueAsDefedant: 0, totalProcessesNotClassifiedWithAuthorOrDefendant: 0, totalProcessesWithRisk: 0, totalProcessesWithRiskActive: 0, totalProcessesWithRiskInactive: 0, totalProcessesWithRiskAsAuthor: 0, totalProcessesWithRiskAsDefendant: 0, totalProcessesWithRiskNotClassifiedWithAuthorOrDefendant: 0, totalProcessesWithRiskWorker: 0, totalProcessesWithRiskExecution: 0, totalProcessesWithRiskCriminal: 0, processesByType: {
            CRIMINAL: __assign({}, emptyType),
            EXECUTION: __assign({}, emptyType),
            WORKER: __assign({}, emptyType),
            OTHER_LITIGATIONS: { total: 0, amount: 0 },
        }, importantTerms: [], summaryAi: summaryAi
            ? __assign(__assign({}, summaryAi), { resumeAi: zeroSummaryAiProcesses(summaryAi.resumeAi) }) : summaryAi });
};
